import React from 'react';
import { Box, HtmlTrans, Typography } from 'web-library';
import { FileUploadState } from '../../../../models/File';
import UploadStateAndAction from '../../../../components/upload-processing-file/UploadStateAndAction';
import { ComponentFileProcessingState, IStylingAndTranslationHooks } from './UploadSection/model';
import DocumentUploader from './UploadSection/DocumentUploader';
import {
  StartFileProcessingErrorActionLabel,
  StartFileProcessingErrorVisualLabel,
} from './UploadSection/StartFileProcessingError';
import FileBadge from '../../../../components/upload-documents/FileBadge';

interface IUploadSection extends IStylingAndTranslationHooks {
  stateHandler: {
    setFileProcessingStatusHandler: {
      fileProcessingStatus?: ComponentFileProcessingState;
      setFileProcessingStatus: React.Dispatch<
        React.SetStateAction<ComponentFileProcessingState | undefined>
      >;
    };
    setUploadedFilesHandler: {
      uploadedFiles: File[];
      setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
    };
  };
  fileStatus?: FileUploadState;
  errorFileDownloadUrl?: string;
  loading: boolean;
  files: File[];
}

const ImportResultsDropzone = ({
  classes,
  translation: t,
  stateHandler,
  fileStatus,
  errorFileDownloadUrl,
  loading,
  files,
}: IUploadSection) => {
  const {
    setFileProcessingStatusHandler: { fileProcessingStatus },
  } = stateHandler;

  return (
    <>
      {!loading && fileProcessingStatus !== ComponentFileProcessingState.ERROR && (
        <Typography className={classes.importResultsStatement} variant="body1">
          {t('exam->>NonNationalExam.ImportResultsInstruction')}
        </Typography>
      )}

      {fileProcessingStatus === ComponentFileProcessingState.ERROR && (
        <Box className={classes.errorProcessingContainer}>
          <UploadStateAndAction
            classes={classes}
            strings={{
              instruction: t('exam->>UploadExcelTemplate.StartFileProcessingErrorInstruction'),
            }}
            labels={{
              visualLabel: (
                <StartFileProcessingErrorVisualLabel classes={classes} translation={t} />
              ),
              actionLabel: (
                <StartFileProcessingErrorActionLabel
                  classes={classes}
                  translation={t}
                  errorFileDownloadUrl={errorFileDownloadUrl}
                />
              ),
            }}
          />
        </Box>
      )}
      {loading && (
        <Typography className={classes.importResultsStatement} variant="body1">
          <HtmlTrans i18nKey="exam->>UploadExcelTemplate.UploadingInProgressInstruction" />
        </Typography>
      )}

      {!loading && (
        <DocumentUploader
          key={fileStatus}
          classes={classes}
          translation={t}
          stateHandler={{
            setUploadedFileHandler: stateHandler.setUploadedFilesHandler,
            setFileProcessingStatusHandler: stateHandler.setFileProcessingStatusHandler,
          }}
        />
      )}
      {loading && (
        <div className={classes.uploadingFileContainer}>
          <FileBadge
            isOpsAdmin={false}
            file={files[0]}
            hasError={false}
            isLoading
            showLoadingText
            onUpdateFileUploadComplete={() => {
              // Do Nothing
            }}
            uploadedFilesHandler={{
              files: [],
              setFiles: () => {
                // Do Nothing
              },
            }}
            loadingText={`${t('common->>Uploading')} `}
          />
        </div>
      )}
    </>
  );
};

export default ImportResultsDropzone;
